export const getIsGlobalLoadingSelector = (state) => state.isGlobalLoading.length > 0;